<form [formGroup]="form" (ngSubmit)="addEmployeeToCrew()">
  <div class="no-wrap">
    <div class="inline-block input-container">
      <fl-autocomplete
        [placeholder]="'Search for Crew Member'"
        [inputControl]="employeeSelected"
        [options]="options$ | async"
        (search)="onSearch($event)"
        required
      >
      </fl-autocomplete>
    </div>
    <div class="inline-block">
      <button
        mat-icon-button
        title="Add Crew Member"
        [disabled]="form.invalid || duplicateSelected"
      >
        <mat-icon>add_circle</mat-icon>
      </button>
    </div>
  </div>
  <div class="inline-block">
    <ng-container *ngIf="isPilotSelected$ | async">
      <label class="mat-check">
        <input type="checkbox" formControlName="pilotInCommand" /> PIC?
      </label>
    </ng-container>
  </div>
</form>
